import Tshirt from '../../assets/images/banner/1.jpg';
import bag from '../../assets/images/product-4.png';
import headphone from '../../assets/images/product-6.jpg';
import chair from '../../assets/images/banner/1.jpg';
import man from '../../assets/images/avtar/man.png';
import teacher from '../../assets/images/avtar/teacher.png';
import teen from '../../assets/images/avtar/teenager.png';
import chinese from '../../assets/images/avtar/chinese.png';

export const messageData = [
    {
        id: 1,
        online: 'status-circle online',
        name: 'Erica Hughes',
        mess: 'okay, trying now.',
        badge: 'badge badge-primary',
        time: '32 min',
    },
    {
        id: 2,
        online: 'status-circle away',
        name: 'Kori Thomas',
        mess: 'i could help in some of bug?',
        badge: 'badge badge-success',
        time: '58 min',
    },
    {
        id: 3,
        online: 'status-circle offline',
        name: 'Ain Chavez',
        mess: 'Its working awesome :)',
        badge: 'badge badge-danger',
        time: '1 hr',
    },
    {
        id: 4,
        online: 'status-circle offline',
        name: 'Johan deo',
        mess: 'Great Thanks you !!',
        badge: 'badge badge-danger',
        time: '2 hr',
    },
];

export const ItemCartData = [
    {
        id: 1,
        img: Tshirt,
        title: 'Black shirt with jecket',
        prize: '$500',
        qty: 'Qty',
    },
    {
        id: 2,
        img: bag,
        title: 'Woman bag - purple',
        prize: '$100',
        qty: 'Qty',
    },
    {
        id: 3,
        img: headphone,
        title: 'Unisex headphone - Red',
        prize: '$200',
        qty: 'Qty',
    },
    {
        id: 4,
        img: chair,
        title: 'Ergonomic Chair',
        prize: '$920',
        qty: 'Qty',
    }
];

export const NotificationData = [
    {
        id: 1,
        img: man,
        name: 'Jhone Doe',
        desp: 'can you help me to find best admin?.',
        time: '10:20',
        class:'bg-light-primary'
    },
    {
        id: 2,
        img: teacher,
        name: 'Jhone Doe',
        desp: 'Sure, zeta is best admin for project.',
        time: '6:20',
        class:'bg-light-secondary'
    },
    {
        id: 3,
        img: teen,
        name: 'Jhone Doe',
        desp: 'you can check it here for admin.',
        time: '5:20',
        class:'bg-light-info'
    },
    {
        id: 4,
        img: chinese,
        name: 'Jhone Doe',
        desp: 'I checked its nice theme, Thanks.',
        time: '1:20',
        class:'bg-light-success'
    }
];